import { useTranslation } from "react-i18next";

function CommentsTurnedOff() {
    const { t } = useTranslation();
    return (
        <div className="mx-auto w-full text-center pt-10">
            {t("responseOverview.commentsTurnedOff")}
        </div>
    );
}

function NoComments() {
    const { t } = useTranslation();
    return (
        <div className="mx-auto w-full text-center pt-10">
            {t("responseOverview.noCommentsAvailable")}
        </div>
    );
}

export { CommentsTurnedOff, NoComments };
